import _ from "lodash";
import { rgbColor } from "../../../enums/colors";
import { Event } from "../../../types/types";

type HistogramProps = {
  width: number;
  height: number;
  data: Event[];
  correctMaintenanceLoad: boolean;
};

// [index, 0, worked, hour, worked]

export const TableEventsHistogram = ({ width, height, data, correctMaintenanceLoad}: HistogramProps) => {
  let dataByHours: [x: number, y: Event[]][] = _.uniqBy(data, el => el[17]).map(x => Number(x[17])).map(h => [h, data.filter(e => e[17] === h)])
  let barWidth = (width / dataByHours.length) - 3
  let predata: {fill: string, x: number, width: number, y: number, height: number}[] = []

  dataByHours.map(([h, data], index) => {
    let worked = _.sum(data.map(e => (
      correctMaintenanceLoad ? 
      [0,6].includes(Number(e[9])) && e[8] === "worked" ? Number(e[7]) : 0 
      : 
      Number(e[9]) === 0 && e[8] === "worked" ? Number(e[7]) : 0
    )))

    let total = _.sum(data.map(e => (
      [0,6].includes(Number(e[9])) ? Number(e[7]) : 0 
    )))

    predata.push({
      fill: rgbColor.worked,
      x: ((barWidth + 2) * Number(index)),
      width: barWidth,
      y: Number(((worked / total) * 100)) ? height - (height / 100 * ((worked / total) * 100)) : 0,
      height: Number(((worked / total) * 100)) ? height * Number(((worked / total) * 100)) : 0
    })
  })

  const allRects = predata.map((bucket, i) => {
    return (
      <rect
        key={i}
        fill={bucket.fill}
        x={bucket.x}
        width={bucket.width}
        y={bucket.y}
        height={bucket.height}
      />
    );
  });

  return (
    predata.length > 0 ? <svg width={width} height={height}>{allRects}</svg> : <></>
  );
};
  